import { ModalPopup, ModalSlideContent } from '@aon/aon-tws-common-ui';
import React from 'react';
import _ from 'lodash';
import { CustomQuestionContainer } from '../../../containers/questions/CustomQuestionContainer';
import { CustomQuestionListContainer } from '../../../containers/questions/CustomQuestionListContainer';
import ContentConstants from '../../../contentConstants';
import { IAddedQuestion } from '../../../models';
import { WarningModal } from '../../common';

interface ICustomQuestionsModalProps {
	activeContentId: number;
	addedQuestions: IAddedQuestion[];
	customQuestionId?: number;
	disableClose: boolean;
	isDemographic: boolean;
	isFollowUp: boolean;
	isOpen: boolean;
	parentQuestionId?: number;
	primaryButtonText?: string;
	secondaryButtonText?: string;
	selectedQuestionVariationIds: number[];
	selectedCustomQuestionIds: number[];
	title: string;
	unsavedQuestionChanges: boolean;
	warningModalOpen: boolean;
	AddOrEditCustomSurveyQuestion: (selectedCustomQuestionId?: number) => void;
	CancelAddOrEditCustomSurveyQuestion: () => void;
	ResetCustomQuestion: () => void;
	SubmitQuestionsModal: (
		addedQuestions: IAddedQuestion[],
		selectedQuestionVariationIds: number[],
		selectedCustomQuestionIds: number[],
		isDemographic: boolean,
	) => void;
	ToggleCustomQuestionsModalWarningModal: (warningModalOpen: boolean) => void;
}

export class CustomQuestionsModal extends React.PureComponent<ICustomQuestionsModalProps> {
	constructor(props: ICustomQuestionsModalProps) {
		super(props);

		this.finishAndCloseModal = this.finishAndCloseModal.bind(this);
		this.handleQuestionFormClose = this.handleQuestionFormClose.bind(this);
		this.onCloseModal = this.onCloseModal.bind(this);
	}

	public render() {
		const totalSelectedQuestions = this.props.selectedQuestionVariationIds.length + this.props.selectedCustomQuestionIds.length;

		return (
			<>
				<ModalPopup
					isOpen={this.props.isOpen}
					title={this.props.title}
					onSubmit={this.props.primaryButtonText !== undefined ? this.finishAndCloseModal : undefined}
					onClosed={this.finishAndCloseModal}
					contentfullwidth={true}
					contenthcentered={true}
					primaryButtonText={this.props.primaryButtonText}
					primaryButtonDisabled={this.props.disableClose}
					secondaryButtonText={this.props.secondaryButtonText}
					secondaryButtonDisabled={this.props.disableClose}
					activeContentId={this.props.activeContentId}
					updateActiveContentId={this.handleQuestionFormClose}
				>
					<ModalSlideContent contentId={1} key={1}>
						<CustomQuestionListContainer
							addedQuestions={this.props.addedQuestions}
							isDemographic={this.props.isDemographic}
							isFollowUp={this.props.isFollowUp}
							parentQuestionId={this.props.parentQuestionId}
							selectedCustomQuestionIds={this.props.selectedCustomQuestionIds}
							onAddUpdateQuestionClick={this.props.AddOrEditCustomSurveyQuestion}
							totalSelectedQuestions={totalSelectedQuestions}
						/>
					</ModalSlideContent>
					<ModalSlideContent contentId={2} key={2}>
						<CustomQuestionContainer
							fromQuestionModal={true}
							isDemographic={this.props.isDemographic}
							isFollowUp={this.props.isFollowUp}
							parentQuestionId={this.props.parentQuestionId}
							questionId={this.props.customQuestionId}
							OnFinish={() => this.props.CancelAddOrEditCustomSurveyQuestion()}
							ToggleWarningModal={this.props.ToggleCustomQuestionsModalWarningModal}
						/>
					</ModalSlideContent>
				</ModalPopup>
				<WarningModal
					isOpen={this.props.warningModalOpen}
					onClose={() => this.props.ToggleCustomQuestionsModalWarningModal(false)}
					onSubmit={this.onCloseModal}
					contentHeadline={ContentConstants.WARNING_MODAL_UNSAVED_HEADLINE}
					contentBody={ContentConstants.WARNING_MODAL_UNSAVED_BODY}
				/>
			</>
		);
	}

	public onCloseModal() {
		this.props.ToggleCustomQuestionsModalWarningModal(false);
		this.props.ResetCustomQuestion();
		this.props.CancelAddOrEditCustomSurveyQuestion();
	}

	public handleQuestionFormClose(_id: number) {
		if (this.props.unsavedQuestionChanges) {
			this.props.ToggleCustomQuestionsModalWarningModal(true);
		} else {
			this.props.CancelAddOrEditCustomSurveyQuestion();
		}
	}

	private finishAndCloseModal() {
		const { addedQuestions, disableClose, isDemographic, selectedCustomQuestionIds, selectedQuestionVariationIds, SubmitQuestionsModal } =
			this.props;
		if (!disableClose) {
			const questionVariationIds = _.uniq(selectedQuestionVariationIds);
			const customQuestionIds = _.uniq(selectedCustomQuestionIds);
			SubmitQuestionsModal(addedQuestions, questionVariationIds, customQuestionIds, isDemographic);
		}
	}
}
